/**
 * Conventions graphiques communes à tous les charts de l'OAD.
 *
 * Deux règles imposées sur l'ensemble de la refonte :
 *  - tout texte (axes, étiquettes, légende, tooltip) en noir et à 14px minimum ;
 *  - le nom de l'axe Y à l'horizontale, au-dessus de l'axe, jamais pivoté.
 *
 * Utilisation : on part de ces fabriques plutôt que de redéclarer les mêmes
 * réglages dans chaque chart.
 *
 *   option = {
 *     ...baseOption(),
 *     xAxis: axeCategorie({ data: categories }),
 *     yAxis: axeValeur({ nom: "Effectif" }),
 *     series: [...],
 *   }
 */

export const TAILLE_TEXTE = 14;
export const COULEUR_TEXTE = '#000000';

const texte = { fontSize: TAILLE_TEXTE, color: COULEUR_TEXTE };

/** Réglages valables pour n'importe quel graphique. */
export function baseOption() {
  return {
    textStyle: { ...texte },
    // grid.top laisse la place au nom de l'axe Y posé au-dessus.
    grid: { left: 12, right: 24, bottom: 12, top: 56, containLabel: true },
    legend: {
      bottom: 0,
      textStyle: { ...texte },
      itemGap: 18,
    },
    tooltip: {
      trigger: 'axis',
      textStyle: { ...texte },
    },
  };
}

/** Axe X catégoriel (le cas courant : cultures, horizons, postes...). */
export function axeCategorie({ data, nom, rotationEtiquettes = 0 } = {}) {
  return {
    type: 'category',
    data,
    name: nom,
    nameLocation: 'middle',
    nameGap: 34,
    nameTextStyle: { ...texte },
    axisLabel: {
      ...texte,
      rotate: rotationEtiquettes,
      interval: 0,
      // Les libellés longs (ex. "Vaches taries & génisses > 2 ans") passent à
      // la ligne au lieu d'être tronqués ou pivotés.
      width: 110,
      overflow: 'break',
      lineHeight: 18,
    },
    axisLine: { lineStyle: { color: '#000000' } },
    axisTick: { alignWithLabel: true },
  };
}

/**
 * Axe Y de valeurs. `nom` est rendu à l'horizontale au-dessus de l'axe :
 * nameLocation 'end' + nameRotate 0 + un décalage vers la gauche pour que le
 * libellé commence au-dessus des graduations plutôt qu'au milieu du graphique.
 */
export function axeValeur({ nom, formatteur, min, max } = {}) {
  return {
    type: 'value',
    name: nom,
    nameLocation: 'end',
    nameRotate: 0,
    nameGap: 24,
    nameTextStyle: { ...texte, fontWeight: 600, align: 'left' },
    min,
    max,
    axisLabel: { ...texte, formatter: formatteur },
    axisLine: { show: true, lineStyle: { color: '#000000' } },
    splitLine: { lineStyle: { color: '#e2e5ea' } },
  };
}
